module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/osago-promotion-d98fda6db50c575ed2623a156abbf040.png";